import { render, staticRenderFns } from "./SpectroGraph.vue?vue&type=template&id=15d52f40&scoped=true&"
import script from "./SpectroGraph.vue?vue&type=script&lang=js&"
export * from "./SpectroGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d52f40",
  null
  
)

export default component.exports